// extracted by mini-css-extract-plugin
export default {"heading":"DefaultBid_heading__WT4u4","wrapper":"DefaultBid_wrapper__Gz9MG","suggestionText":"DefaultBid_suggestionText__JZAJt","pandaImg":"DefaultBid_pandaImg__BYp+n"};